module.exports = __webpack_public_path__ + "media/icon/icon_unfold_more-9432381d.svg";